import React from "react";
import "./loader.css";


const Loader = ({ small }) => {
  return (
    <div class="loader"></div>
  );
};

export default Loader;
